import { memo } from 'react'

const LocationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 3.801c-1.65 0-3.233.664-4.4 1.846a6.343 6.343 0 0 0-1.822 4.457c0 2.576 1.584 5.062 3.322 6.988.89.98 1.86 1.883 2.9 2.697a23.243 23.243 0 0 0 2.9-2.696c1.738-1.927 3.322-4.412 3.322-6.99A6.343 6.343 0 0 0 16.4 5.647 6.183 6.183 0 0 0 12 3.801ZM12 22l-.504-.351-.003-.002-.005-.004-.018-.013-.066-.048-.24-.177a25.005 25.005 0 0 1-3.376-3.097C5.972 16.293 4 13.377 4 10.103c0-2.15.843-4.21 2.343-5.73A7.949 7.949 0 0 1 12 2a7.95 7.95 0 0 1 5.657 2.373A8.156 8.156 0 0 1 20 10.103c0 3.274-1.972 6.19-3.788 8.203a25.006 25.006 0 0 1-3.375 3.097 15.3 15.3 0 0 1-.306.226l-.019.013-.005.004-.002.001L12 22Zm0-13.697c-.472 0-.924.19-1.257.527-.334.338-.52.796-.52 1.274 0 .477.186.935.52 1.273a1.766 1.766 0 0 0 2.514 0c.334-.338.52-.796.52-1.274 0-.477-.186-.935-.52-1.273A1.766 1.766 0 0 0 12 8.303Zm-3.556 1.8c0-.955.375-1.87 1.042-2.546A3.533 3.533 0 0 1 12 6.502c.943 0 1.847.38 2.514 1.055a3.625 3.625 0 0 1 1.042 2.546c0 .956-.375 1.872-1.042 2.547A3.533 3.533 0 0 1 12 13.705c-.943 0-1.847-.38-2.514-1.055a3.625 3.625 0 0 1-1.042-2.546Z"
    />
  </svg>
)

export default memo(LocationIcon)
